const DEVICES_BOTTOM_SHEET = 'roaming-devices-bottom-sheet';
const SELECT_BRAND_BOTTOM_SHEET = 'roaming-select-device-bottom-sheet';

const DEVICES = [
  {
    title: 'Apple',
    items: [
      'iPhone XR',
      'iPhone XS / XS Max',
      'iPhone 11 Series',
      'iPhone SE (2nd and 3rd Generation)',
      'iPhone 12 Series',
      'iPhone 13 Series',
      'iPhone 14 Series',
      'iPhone 15 Series',
      'iPhone 16 Series',
      'Pad Pro 11-inch (1st to 3rd Generation, from 2020)',
      'iPad Pro 12.9-inch (3rd to 5th Generation, from 2020)',
      'iPad Air (3rd and 4th Generation, from 2019)',
      'iPad (7th to 9th Generation, from 2019)',
      'iPad Mini (5th and 6th Generation, from 2019)',
    ],
  },
  {
    title: 'Samsung',
    items: [
      'Galaxy S20 / S20+ / S20 Ultra',
      'Galaxy S21 / S21+ / S21 Ultra',
      'Galaxy S22 / S22+ / S22 Ultra',
      'Galaxy S23 / S23+ / S23 Ultra',
      'Galaxy S24 / S24+ / S24 Ultra',
      'A54 / A54 5G',
      'A35 5G',
      'A55 5G',
      'Galaxy Note 20 / Note 20 Ultra',
      'Galaxy Fold Series',
      'Galaxy Z Flip Series',
    ],
  },
  {
    title: 'Google Pixel',
    items: [
      'Pixel 2 / 2 XL',
      'Pixel 3 / 3 XL',
      'Pixel 3a / 3a XL',
      'Pixel 4 / 4a / 4 XL',
      'Pixel 5 / 5a',
      'Pixel 6 / 6 Pro',
      'Pixel 7 / 7 Pro',
      'Pixel 8 / 8 Pro',
      'Pixel 9 / 9 Pro',
    ],
  },
  {
    title: 'Huawei',
    items: ['P40 / P40 Pro', 'Mate 40 Pro'],
  },
  {
    title: 'Oppo',
    items: [
      'Find X3 / X3 Pro',
      'Find X5 / X5 Pro',
      'Reno 5A / 9A',
      'Reno 6 Pro 5G',
      'A55s 5G',
    ],
  },
  {
    title: 'Motorola',
    items: [
      'Razr 2019',
      'Razr 5G',
      'Razr 40 / 40 Ultra',
      'Edge+ Series',
      'Edge 40 / 40 Pro',
      'G Series 34/52/53/54/84',
    ],
  },
  {
    title: 'Sony',
    items: [
      'Xperia 10 III Lite',
      'Xperia 10 IV',
      'Xperia 1 IV',
      'Xperia 5 IV',
      'Sony Xperia 1 V',
      'Sony Xperia Ace III',
      'Sony Xperia 5 V',
    ],
  },
  {
    title: 'Xiaomi',
    items: [
      '12T Pro',
      '13 / 13 Lite / 13 Pro / 13T Pro',
      '14 / 14 Pro',
      'Blackshark 3',
    ],
  },
  {
    title: 'Honor',
    items: [
      'Magic 4 Pro',
      'Magic 5 Pro',
      'Magic 6 Pro',
      'Honor 90',
      'Honor X8',
    ],
  },
  {
    title: 'Fairphone',
    items: ['Fairphone 4'],
  },
  {
    title: 'OnePlus',
    items: [
      'OnePlus 11 (Global version only, Indian/Chinese models not supported)',
      'OnePlus 12 (Global version only, Indian/Chinese models not supported)',
      'OnePlus 13 (Global version only, Indian/Chinese models not supported)',
    ],
  },
  {
    title: 'Nokia',
    items: ['XR21', 'X30', 'G60 5G'],
  },
  {
    title: 'VIVO',
    items: [
      'X90 Pro',
      'X100 Pro',
      'V29 Lite 5G(Support only in Europe)',
      'V29(Only supported in Europe and Latin America)',
      'V40 SE 5G, V40 Lite',
    ],
  },
  {
    title: 'Infinix',
    items: ['GT 10 Pro', 'Note 30 5G', 'Zero 5G'],
  },
  {
    title: 'Tecno',
    items: ['Tecno Spark Go'],
  },
  {
    title: 'Sharp',
    items: ['Sharp Aquos Sense6s', 'Sharp Aquos Wish'],
  },
  {
    title: 'Laptops',
    items: [
      'Various models from Acer, ASUS, Dell, HP, and Lenovo support eSIM functionality',
    ],
  },
];

const APPLE = 'apple';
const SAMSUNG = 'samsung';
const GOOGLE = 'google';
const HUAWEI = 'huawei';
const LAPTOP = 'laptop';
const OPPPO = 'oppo';
const OTHERS = 'others';

const INSTRUCTIONS_BRANDS = {
  [APPLE]: 'Apple',
  [SAMSUNG]: 'Samsung',
  [GOOGLE]: 'Google',
  [HUAWEI]: 'Huawei',
  [LAPTOP]: 'Laptops & Notebook',
  [OPPPO]: 'Oppo',
  [OTHERS]: 'Others',
};

const ROAMING = 'roaming';

// Базовая конфигурация роуминга, которую можно расширять в других приложениях
export const BaseRoamingConfig = {
  DEVICES,
  DEVICES_BOTTOM_SHEET,
  ROAMING,
  INSTRUCTIONS_BRANDS,
  SELECT_BRAND_BOTTOM_SHEET,
  APPLE,
  SAMSUNG,
  GOOGLE,
  HUAWEI,
  LAPTOP,
  OPPPO,
  OTHERS,
};

// Стандартная конфигурация для обратной совместимости
export const roamingConfig = BaseRoamingConfig;
